export default __webpack_public_path__ + "static/pause-sub-e38a06bb156c545039c5bb53752f2a6b.png";